import { Link } from "react-router-dom";
import { LOGO_URL, INSTAGRAM_URL, CONTACT_EMAIL } from "../config/brand";

const LinkItem = ({ to, children, testid, external }) =>
  external ? (
    <a
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className="text-[11px] font-medium tracking-[0.18em] hover:opacity-40 transition-opacity"
    >
      {children}
    </a>
  ) : (
    <Link
      to={to}
      data-testid={testid}
      className="text-[11px] font-medium tracking-[0.18em] hover:opacity-40 transition-opacity"
    >
      {children}
    </Link>
  );

export const Footer = () => (
  <footer className="border-t border-black/10 mt-24" data-testid="site-footer">
    <div className="flex flex-col items-center gap-8 px-4 py-14">
      <Link to="/" aria-label="Rich Kids Funeral — home">
        <img src={LOGO_URL} alt="Rich Kids Funeral" className="h-8 md:h-10 w-auto" />
      </Link>
      <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3" aria-label="Shop">
        <LinkItem to="/all-products" testid="footer-shop-link">SHOP</LinkItem>
        <LinkItem to="/editorial" testid="footer-editorial-link">EDITORIAL</LinkItem>
        <LinkItem to="/about" testid="footer-about-link">ABOUT</LinkItem>
        <LinkItem to={INSTAGRAM_URL} testid="footer-instagram-link" external>INSTAGRAM</LinkItem>
      </nav>
      <nav className="flex flex-wrap justify-center gap-x-8 gap-y-3" aria-label="Support">
        <LinkItem to="/contact" testid="footer-contact-link">CONTACT</LinkItem>
        <LinkItem to="/shipping" testid="footer-shipping-link">SHIPPING</LinkItem>
        <LinkItem to="/returns" testid="footer-returns-link">RETURNS</LinkItem>
        <LinkItem to="/privacy" testid="footer-privacy-link">PRIVACY</LinkItem>
        <LinkItem to="/terms" testid="footer-terms-link">TERMS</LinkItem>
      </nav>
      <a
        href={`mailto:${CONTACT_EMAIL}`}
        data-testid="footer-email-link"
        className="text-[10px] tracking-[0.18em] text-black/50 hover:opacity-60 transition-opacity"
      >
        {CONTACT_EMAIL.toUpperCase()}
      </a>
      <p className="text-[10px] tracking-[0.1em] text-black/60">© 2026 RICH KIDS FUNERAL</p>
    </div>
  </footer>
);
